export const Footer = () => {
    return (
        <>
            <footer className="footer">
                <p className="footer-text">© 2024 Creativblume. Alle Rechte vorbehalten.</p>
            </footer>
        </>
    )
}